<template>
  <div>
    <el-tabs type="border-card" class="fullHeight" @tab-click="setVigente">
      <el-tab-pane :label="$t('Inventarios / Contratos Vigentes')" class="paddingBody">
        <el-alert :closable="false" style="margin-bottom: 30px;"
          v-if="visibleAlertAnual && (['contractor_coordinator', 'coordinator', 'super', 'owner', 'contract_owner'].includes($store.getters.role.role) || $store.getters.role.admin === true)"
          class="intermitente" title="Información importante" size="small" show-icon type="warning">
          <div style="margin-top: 10px; font-size: 14px; color: black;">
            Le informamos que en la actualidad tiene <b>{{ countAnual }}</b> inventario(s) de riesgos que requieren la
            {{ ["contractor_coordinator", "coordinator"].includes($store.getters.role.role) ? "realización" :
              "evaluación" }} de la revisión anual,
            si desconoce como realizarla a continuación puede ver el videotutorial y/o descargar el PDF con las
            instrucciones para realizar el proceso.<br>
            <el-button :icon="showVideo === true ? 'el-icon-caret-top' : 'el-icon-caret-bottom'"
              @click="showVideo = !showVideo" style="margin-top: 15px;" type="danger" size="small">{{ showVideo === true
                ? "Ocultar" : "Ver" }} video tutorial</el-button>
            <a v-if="['contractor_coordinator', 'coordinator'].includes($store.getters.role.role)" download
              style="margin-left: 30px" href="/files/anual_coordinador.pdf">
              <el-button icon="el-icon-download" style="margin-top: 15px;" type="info" size="small">Descargar PDF /
                Coordinador</el-button>
            </a>
            <a v-if="['super', 'owner'].includes($store.getters.role.role)" download style="margin-left: 30px"
              href="/files/anual_revisor.pdf">
              <el-button icon="el-icon-download" style="margin-top: 15px;" type="info" size="small">Descargar PDF -
                Revisor</el-button>
            </a>
            <br><br>
            <iframe style="margin-right: 30px;"
              v-if="(['contractor_coordinator', 'coordinator'].includes($store.getters.role.role) || $store.getters.role.admin === true) && showVideo === true"
              width="560" height="315" src="https://www.youtube.com/embed/pYqLPPjLeTE"
              title="Realizar Revisión Anual Coordinador" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
            <iframe
              v-if="(['super', 'owner'].includes($store.getters.role.role) || $store.getters.role.admin === true) && showVideo === true"
              width="560" height="315" src="https://www.youtube.com/embed/m1vRl2V-2a0?si=OfJD-diuarEB2qv"
              title="Validador de la revisión anual" frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen></iframe>
          </div>
        </el-alert>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form onsubmit="return false;">
              <el-form-item label="Búsqueda avanzada">
                <el-input :placeholder="$t('Búsqueda por nombre del inventario')" prefix-icon="el-icon-search"
                  v-model="search" style="width: 100%;" size="medium" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="3">
            <el-form onsubmit="return false;">
              <el-form-item label="Tipo de contrato">
                <el-select style="width: 100%;" size="medium" v-model="contractType" placeholder="Seleccione tipo">
                  <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-if="contractType === 'Contratista' && $store.getters.role.admin === true" :span="3">
            <el-form label-position="top" onsubmit="return false;" style="text-align: center;">
              <el-form-item label="Sub-contratos">
                <el-switch v-model="subcontrato" @change="setSubcontrato">
                </el-switch>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col v-if="subcontrato === true && $store.getters.role.admin === true" :span="5">
            <el-form label-position="top" onsubmit="return false;">
              <el-form-item label="Seleccione empresa mandante">
                <el-select filterable @change="setMandante" size="medium" v-model="empresa_mandante"
                  placeholder="Seleccione estado">
                  <el-option label="Todas las empresas" :value="null"></el-option>
                  <el-option v-for="item in subcontratistas" :key="item.subcontrato_empresa_id" :label="item.empresa"
                    :value="item.subcontrato_empresa_id"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <center v-if="loading">
              <br />
              <br />
              <Circle9 style="margin-bottom: 8px"></Circle9>
              <small>Cargando Datos ...</small>
              <br />
              <br />
            </center>
            <el-table v-else :data="paginar === false ? inventarios : paginarInventarios()" class="inventoryTable"
              :max-height="700" :header-cell-style="function () {
                return 'background-color: #242424; color: white; padding: 0px; border-width: 2px;';
              }
                ">
              <el-table-column :label="$t('Área')" prop="area_id" sortable>
                <template slot-scope="scope">{{
                  scope.row.data_area
                    ? scope.row.data_area.nombre
                    : "Área no encontrada"
                }}</template>
              </el-table-column>
              <el-table-column :label="$t('Empresa')" v-if="contractType !== 'Propio'" prop="empresa_id" sortable>
                <template slot-scope="scope">{{
                  getCompanyName(scope.row.empresa_id)
                }}</template>
              </el-table-column>
              <el-table-column :label="$t('Faena')" v-if="contractType == 'Propio'" width="250" sortable>
                <template slot-scope="scope">{{ faena }}</template>
              </el-table-column>
              <el-table-column :label="$t('Nombre')" prop="nombre" sortable></el-table-column>
              <el-table-column :label="$t('N° Contrato')" v-if="contractType == 'contratista'" prop="numero_contrato"
                width="130px" sortable></el-table-column>
              <el-table-column label="Estado" align="center" width="225">
                <template slot-scope="scope">
                  <span :class="`safety-tag font_size_22px inventario_estado inventario_estado_${JSON.stringify(scope.row.inventario) !== 'null'
                    ? scope.row.inventario.status
                    : 'undefined'
                    }`">{{ getStatus(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Opciones')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button style="width: 100%" size="mini" :type="scope.row.inventario && scope.row.inventario.status
                    ? 'info'
                    : 'primary'
                    " :icon="scope.row.inventario && scope.row.inventario.status
                      ? 'el-icon-view'
                      : 'el-icon-edit'
                      " @click="selectContract(scope.row)"><b>{{
                        scope.row.inventario &&
                          [1, 4, 2, "1", "4", "2"].includes(
                            scope.row.inventario.status
                          )
                          ? "Ver inventario"
                          : !scope.row.inventario
                            ? "Crear inventario"
                            : "Editar inventario"
                      }}</b></el-button><br />
                  <el-button @click="setStatusEdit(scope.row._id)" v-if="!$store.getters.user.readonly &&
                    [
                      '608c08fc3fdf700017e11c95',
                      '5b929a761616050010f76dff',
                      '59cbfb0c0a1d7d0011ba7860',
                      '655ca26350599500126cc6e2',
                      '642198cb8c03c500123c0d94'
                    ].includes($store.getters.user._id)
                  " plain icon="el-icon-setting" style="width: 100%; margin-top: 5px" size="mini"><b>Cambiar
                      estado</b></el-button>
                  <div v-if="!$store.getters.user.readonly &&
                    [
                      '608c08fc3fdf700017e11c95',
                      '5b929a761616050010f76dff',
                      '59cbfb0c0a1d7d0011ba7860',
                      '655ca26350599500126cc6e2',
                      '642198cb8c03c500123c0d94'
                    ].includes($store.getters.user._id) && scope.row.inventario && [2, '2'].includes(scope.row.inventario.status)
                  ">
                    <el-button type="danger" @click="setDate(scope.row._id, scope.row.inventario)" plain
                      icon="el-icon-setting" style="width: 100%; margin-top: 5px" size="mini"><b>Cambiar
                        fecha</b></el-button>
                  </div>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Requiere revisión anual')" align="center" width="140">
                <template slot-scope="scope">
                  <el-tag style="
                      background-color: red;
                      color: white;
                      font-weight: bold;
                    " v-if="validarRevisar(scope.row.inventario, scope.row)" type="danger">SI</el-tag>
                  <el-tag v-else style="
                      background-color: green;
                      color: white;
                      font-weight: bold;
                    " type="success">NO</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center :class="{ 'display-none': loading }">
              <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
                @current-change="currentPage" :page-size="5" layout="prev, pager, next" :total="totalPage" />
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
      <el-tab-pane :label="$t('Inventarios / Contratos Vencidos')" class="paddingBody">
        <el-row>
          <el-col :span="11">
            <el-form onsubmit="return false;" label-position="left">
              <el-form-item label="Búsqueda avanzada">
                <el-input :placeholder="$t('Búsqueda por nombre del inventario')" prefix-icon="el-icon-search"
                  v-model="search" class="search" size="medium" />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="24">
            <center v-if="loading">
              <br />
              <br />
              <Circle9 style="margin-bottom: 8px"></Circle9>
              <small>Cargando Datos ...</small>
              <br />
              <br />
            </center>
            <el-table v-else :data="paginar === false ? inventarios : paginarInventarios()" class="inventoryTable"
              :max-height="700" :header-cell-style="function () {
                return 'background-color: #242424; color: white; padding: 0px; border-width: 2px;';
              }
                ">
              <el-table-column :label="$t('Area')" prop="area_id" sortable>
                <template slot-scope="scope">{{
                  scope.row.data_area
                    ? scope.row.data_area.nombre
                    : "Área no encontrada"
                }}</template>
              </el-table-column>
              <el-table-column :label="$t('Empresa')" v-if="contractType !== 'Propio'" prop="empresa_id" sortable>
                <template slot-scope="scope">{{
                  getCompanyName(scope.row.empresa_id)
                }}</template>
              </el-table-column>
              <el-table-column :label="$t('Faena')" v-if="contractType == 'Propio'" width="250" sortable>
                <template slot-scope="scope">{{ faena }}</template>
              </el-table-column>
              <el-table-column :label="$t('Nombre')" prop="nombre" sortable></el-table-column>
              <el-table-column :label="$t('N° Contrato')" v-if="contractType == 'contratista'" prop="numero_contrato"
                width="130px" sortable></el-table-column>
              <el-table-column label="Estado" align="center" width="225">
                <template slot-scope="scope">
                  <span :class="`safety-tag font_size_22px inventario_estado inventario_estado_${JSON.stringify(scope.row.inventario) !== 'null'
                    ? scope.row.inventario.status
                    : 'undefined'
                    }`">{{ getStatus(scope.row) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="$t('¿Contrato habilitado?')" align="center" width="170">
                <template slot-scope="scope">
                  <el-tag style="
                      background-color: red;
                      color: white;
                      font-weight: bold;
                    " v-if="scope.row.hidden" type="danger">NO</el-tag>
                  <el-tag v-else style="
                      background-color: green;
                      color: white;
                      font-weight: bold;
                    " type="success">SI</el-tag>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Opciones')" align="center" width="200">
                <template slot-scope="scope">
                  <el-button style="width: 100%" size="small" :type="scope.row.inventario && scope.row.inventario.status
                    ? 'info'
                    : 'primary'
                    " :icon="scope.row.inventario && scope.row.inventario.status
                      ? 'el-icon-view'
                      : 'el-icon-edit'
                      " @click="selectContract(scope.row)"><b>{{
                        scope.row.inventario &&
                          [1, 4, 2, "1", "4", "2"].includes(
                            scope.row.inventario.status
                          )
                          ? "Ver inventario"
                          : !scope.row.inventario
                            ? "Crear inventario"
                            : "Editar inventario"
                      }}</b></el-button><br />
                  <el-button @click="setStatusEdit(scope.row._id)" v-if="[
                    '608c08fc3fdf700017e11c95',
                    '5b929a761616050010f76dff',
                    '59cbfb0c0a1d7d0011ba7860',
                    '5e41686693114800178f246f'
                  ].includes($store.getters.user._id)
                  " plain icon="el-icon-setting" style="width: 100%; margin-top: 5px" size="mini"><b>Cambiar
                      estado</b></el-button><br>
                  <el-button v-if="[
                    '608c08fc3fdf700017e11c95',
                    '5b929a761616050010f76dff',
                    '59cbfb0c0a1d7d0011ba7860',
                    '5e41686693114800178f246f',
                    '642198cb8c03c500123c0d94',
                    '655ca26350599500126cc6e2'
                  ].includes($store.getters.user._id)
                  " plain type="warning" @click="ocultarContrato(scope.row)" style="width: 100%; margin-top: 5px"
                    size="small"><b>{{ scope.row.hidden ? "Habilitar Contrato" : "Deshabilitar Contrato"
                      }}</b></el-button>
                </template>
              </el-table-column>
              <el-table-column :label="$t('PDF')" align="center" width="125">
                <template slot-scope="scope">
                  <el-button v-if="scope.row.inventario &&
                    scope.row.inventario.status &&
                    parseInt(scope.row.inventario.status, 10) === 2
                  " size="small" type="danger" icon="el-icon-download"
                    @click="downloadPDF(scope.row.inventario._id)">Descargar</el-button>
                </template>
              </el-table-column>
              <el-table-column :label="$t('Requiere revisión anual')" align="center" width="140">
                <template slot-scope="scope">
                  <el-tag style="
                      background-color: red;
                      color: white;
                      font-weight: bold;
                    " v-if="validarRevisar(scope.row.inventario, scope.row)" type="danger">SI</el-tag>
                  <el-tag v-else style="
                      background-color: green;
                      color: white;
                      font-weight: bold;
                    " type="success">NO</el-tag>
                </template>
              </el-table-column>
            </el-table>
            <br />
            <br />
            <center :class="{ 'display-none': loading }">
              <el-pagination :current-page="page" @prev-click="backPage" @next-click="nextPage"
                @current-change="currentPage" :page-size="5" layout="prev, pager, next" :total="totalPage" />
            </center>
          </el-col>
        </el-row>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="Cambiar estado del inventario" :visible.sync="dialogStatus" width="30%"
      :before-close="handleClose">
      <div style="margin-top: 25px">
        <span>Seleccione un estado del inventario</span>
        <el-select style="width: 100%; margin-top: 7px" v-model="nuevo_status" placeholder="Seleccione un estado">
          <el-option v-for="item in estados" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="cambiarEstado">Aceptar</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Cambiar fecha de aprobación" :visible.sync="dialogDate" width="20%" :before-close="handleClose">
      <div style="margin-top: 25px">
        <span>Seleccione una fecha de aprobación</span>
        <div style="margin-top: 10px;">
          <el-date-picker format="dd-MM-yyyy" style="width: 100%;" v-model="fecha_aprobacion" type="date"
            placeholder="Seleccione un día">
          </el-date-picker>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">Cancelar</el-button>
        <el-button type="primary" @click="cambiarFecha">Aceptar</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { Circle9 } from "vue-loading-spinner";
import { mapGetters, mapActions } from "vuex";
import { contractorRoles } from "@/utils/generalObjects.js";
import moment from "moment";
import axios from "axios";
import funPdf from "@/utils/funPdf/funPdf";

const { downloadPDF } = funPdf;

export default {
  data() {
    return {
      empresa_mandante: null,
      subcontratistas: [],
      subcontrato: false,
      subcontrato_empresa_id: null,
      fecha_aprobacion: "",
      countAnual: 0,
      showVideo: false,
      visibleAlertAnual: false,
      id_status: "",
      estados: [
        {
          value: 0,
          label: "Borrador",
        },
        {
          value: 1,
          label: "Revisión",
        },
        {
          value: 2,
          label: "Aprobado",
        },
        {
          value: 3,
          label: "Importado Borrador",
        },
        {
          value: 4,
          label: "Evaluación Medio Ambiente",
        },
      ],
      nuevo_status: "",
      dialogStatus: false,
      dialogDate: false,
      options: [
        {
          value: "Contratista",
          label: "Contratista",
        },
      ],
      inventarios: [],
      loading: false,
      contractorRoles,
      contractType: "Contratista",
      faena: "",
      selectedContract: "",
      isLoadingPDF: false,
      inventario_estado: {
        0: "Borrador",
        1: "En revisión",
        2: "Aprobado",
        3: "Importado Borrador",
        4: "Validación de Medioambiente",
      },
      page: 1,
      totalPage: 0,
      paginar: false,
      search: "",
      vencido: false,
    };
  },
  components: {
    Circle9,
  },
  computed: {
    ...mapGetters({
      areas: "areas",
      actualRole: "actualRole",
      empresas: "empresas",
    }),
    contracts() {
      return this.$store.getters.userContracts || [];
    },
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  async mounted() {
    if (this.$store.getters.areas.length === 0) {
      await this.getAreasFaena().then(() => { });
    }
  },
  async created() {
    // Título página
    this.setSubTitle(this.$t("Listado inventarios de riesgos"));
    this.listadoInventarios(1, this.search);
    if (this.$store.getters.empresas.length === 0) this.getEmpresasFaena();
    this.faena = this.$store.getters.faenasRoles.find(
      (f) => f._id === this.$store.getters.role.faena_id
    ).nombre;
    if (
      this.$store.getters.role.admin === true ||
      ![
        "contractor_coordinator",
        "contractor_hse",
        "administrator",
        "contract_owner",
      ].includes(this.$store.getters.role.role)
    ) {
      this.options.push({
        value: "Propio",
        label: "Propio",
      });
    }
    this.validarAnual();
  },
  watch: {
    contractType() {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
      this.validarAnual();
    },
    search() {
      this.loading = true;
      this.debounceInputSearch();
    },
  },
  methods: {
    ...mapActions(["setSubTitle", "getAreasFaena", "getEmpresasFaena"]),
    async ocultarContrato(contrato) {
      this.$confirm("¿Estas seguro que deseas continuar?", "Advertencia", {
        confirmButtonText: "Aceptar",
        cancelButtonText: "Cancelar",
        type: "warning",
      })
        .then(async () => {
          const config = {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          };

          let response = await axios.post(
            `/contratos/hiddenContract`,
            {
              _id: contrato._id,
              hidden: !contrato.hidden,
            },
            config
          );

          if (response.data.success === true) {
            this.$alert(response.data.message, "Información", {
              type: "success",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            });
            this.listadoInventarios(this.page, this.search);
          } else {
            this.$alert(response.data.message, "Información", {
              type: "error",
              confirmButtonText: "Aceptar",
              callback: (action) => { },
            });
          }
        })
        .catch(() => { });
    },
    setSubcontrato() {
      this.empresa_mandante = null;
      this.listadoInventarios(this.page, this.search);
      if (this.subcontrato === true) {
        this.getSubcontratistas();
      }
    },
    setMandante() {
      this.listadoInventarios(this.page, this.search);
    },
    async getSubcontratistas() {
      let response = await axios.post(
        `/contratos/getEmpresasSubcontratistas`,
        {
          faena_id: this.$store.getters.role.faena_id
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      this.subcontratistas = response.data;
    },
    async cambiarFecha() {
      if (this.fecha_aprobacion !== "") {
        this.$confirm("¿Estas seguro que deseas continuar?", "Advertencia", {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        })
          .then(async () => {
            const config = {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            };

            let response = await axios.post(
              `/inventarios/setDateInventory`,
              {
                id: this.id_status,
                fecha: this.fecha_aprobacion,
              },
              config
            );

            if (response.data.status === true) {
              this.$alert(response.data.message, "Información", {
                type: "success",
                confirmButtonText: "Aceptar",
                callback: (action) => { },
              });
              this.handleClose();
              this.listadoInventarios(this.page, this.search);
            } else {
              this.$alert(response.data.message, "Información", {
                type: "error",
                confirmButtonText: "Aceptar",
                callback: (action) => { },
              });
            }
          })
          .catch(() => { });
      } else {
        this.$alert("No has seleccionado ningún estado", "Información", {
          type: "warning",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
    async cambiarEstado() {
      if (this.nuevo_status !== "") {
        this.$confirm("¿Estas seguro que deseas continuar?", "Advertencia", {
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          type: "warning",
        })
          .then(async () => {
            const config = {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            };

            let response = await axios.post(
              `/contratos/setStatusInventory`,
              {
                _id: this.id_status,
                status: this.nuevo_status,
              },
              config
            );

            if (response.data.success === true) {
              this.$alert(response.data.message, "Información", {
                type: "success",
                confirmButtonText: "Aceptar",
                callback: (action) => { },
              });
              this.handleClose();
              this.listadoInventarios(this.page, this.search);
            } else {
              this.$alert(response.data.message, "Información", {
                type: "error",
                confirmButtonText: "Aceptar",
                callback: (action) => { },
              });
            }
          })
          .catch(() => { });
      } else {
        this.$alert("No has seleccionado ningún estado", "Información", {
          type: "warning",
          confirmButtonText: "Aceptar",
          callback: (action) => { },
        });
      }
    },
    handleClose() {
      this.dialogStatus = false;
      this.nuevo_status = "";
      this.id_status = "";
      this.dialogDate = false;
    },
    setStatusEdit(id) {
      this.id_status = id;
      this.dialogStatus = true;
    },
    setDate(id, inventario) {
      var inv = JSON.parse(JSON.stringify(inventario));
      this.fecha_aprobacion = inv.created_at;
      this.id_status = id;
      this.dialogDate = true;
    },
    setVigente(tab) {
      this.page = 1;
      this.search = "";
      if (tab.label === "Inventarios / Contratos Vencidos") {
        this.contractType = "Contratista";
        this.vencido = true;
        this.listadoInventarios(this.page, this.search);
      }
      if (tab.label === "Inventarios / Contratos Vigentes") {
        this.vencido = false;
        this.listadoInventarios(this.page, this.search);
      }
    },
    validarRevisar(inventario, contract) {
      if (
        inventario &&
        ["2", 2].includes(inventario.status) &&
        this.isActiveContract(contract)
      ) {
        if (
          !inventario.hasOwnProperty("reviewer") ||
          inventario.reviewer.length === 0
        ) {
          if (this.diasDiff(inventario.created_at) >= 365) {
            return true;
          } else {
            return false;
          }
        } else {
          if (
            this.diasDiff(
              inventario.reviewer[inventario.reviewer.length - 1]["date"]
            ) >= 365 ||
            inventario.reviewer[inventario.reviewer.length - 1]["aprobado"] ===
            null ||
            inventario.reviewer[inventario.reviewer.length - 1]["aprobado"] ===
            false
          ) {
            return true;
          } else {
            return false;
          }
        }
      } else {
        return false;
      }
    },
    diasDiff(date) {
      var fecha1 = moment(date);
      var fecha2 = moment();
      return fecha2.diff(fecha1, "days");
    },
    getStatus(row) {
      if (!row.inventario) {
        return "No iniciado";
      }
      if (row.inventario.wasApproved === true) {
        if (row.inventario.status === 1 || row.inventario.status === 0) {
          return "Aprobado en actualización";
        }
      }
      /* if (row.inventario && !row.inventario.status) {
        return "No iniciado";
      } */
      return this.inventario_estado[row.inventario.status];
    },
    debounceInputSearch: _.debounce(function () {
      this.page = 1;
      this.listadoInventarios(this.page, this.search);
    }, 1200),
    paginarInventarios() {
      return this.inventarios.slice((this.page - 1) * 5, this.page * 5);
    },
    currentPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    nextPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    backPage(page) {
      this.page = page;
      this.listadoInventarios(page, this.search);
    },
    getAreaName(id) {
      if (this.areas.length > 0) {
        const area = this.areas.find((a) => a._id === id);
        if (area) {
          return area.nombre;
        }
      }
      return id;
    },
    getCompanyName(id) {
      if (this.empresas.length > 0) {
        const empresa = this.empresas.find((e) => e._id === id);
        if (empresa) {
          return empresa.nombre;
        }
      }
      return id;
    },
    isActiveContract(contract) {
      if (contract.tipo_contrato === "Propio") {
        return true;
      }
      return moment(contract.fecha_fin) - new Date() >= 0;
    },
    listadoInventarios(page, search) {
      this.loading = true;
      const self = this;
      let url = `/contratos/byUFAER?vencido=${this.vencido}&userId=${this.$store.getters.user._id}&faenaId=${this.$store.getters.role.faena_id}&subcontrato=${this.subcontrato}&empresa_mandante=${this.empresa_mandante}`;
      url = this.$store.getters.role.admin
        ? `${url}&role=admin`
        : this.$store.getters.role.area_id === "GeneralAreasRoles"
          ? `${url}&role=allAreas`
          : `${url}&role=${this.$store.getters.role.role}`;
      url += `&actualRole=${this.$store.getters.role.role}`;
      if (this.$store.getters.role.area_id) {
        url = `${url}&areaId=${this.$store.getters.role.area_id}`;
      }
      if (this.$store.getters.role.empresa_id) {
        url = `${url}&empresaId=${this.$store.getters.role.empresa_id}`;
      }
      axios
        .get(
          `${url}&page=${page}&tipo=${this.contractType}&search=${search === "" ? undefined : search
          }`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then((response) => {
          self.inventarios = response.data.contratos.results;
          self.totalPage = response.data.contratos.total;
          self.paginar = response.data.contratos.paginar;
          self.loading = false;
        });
    },
    async validarAnual() {
      this.visibleAlertAnual = false;
      var response = await axios.get(`/inventarios/validar_revisiones_anuales/${this.$store.getters.role.role}/${this.contractType}/${this.$store.getters.role.faena_id}/${this.$store.getters.user._id}/${this.$store.getters.role.area_id}/${this.$store.getters.role.admin}/${this.$store.getters.role.empresa_id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      this.countAnual = response.data.countAnual;
      this.visibleAlertAnual = response.data.visible;
    },
    selectContract(contract) {
      // Redireccionar según el perfil del usuario y
      // estado del inventario.
      const { role } = this.$store.getters;
      let url = `/inventario/${contract._id}/ver`;
      if (this.isActiveContract(contract)) {
        if (
          role.admin ||
          ["coordinator", "contractor_coordinator"].includes(role.role)
        ) {
          if (contract.inventario && contract.inventario.status) {
            switch (parseInt(contract.inventario.status, 10)) {
              case 1:
              case 4:
                url = `/inventario/${contract._id}/revisar`;
                break;
              case 2:
                url = `/inventario/${contract._id}/ver`;
                break;
              case 0:
              case 3:
              default:
                url = `/inventario/${contract._id}/editar`;
            }
          } else {
            url = `/inventario/${contract._id}/editar`;
          }
        } else if (
          contract.inventario &&
          contract.inventario.status &&
          parseInt(contract.inventario.status, 10) === 1
        ) {
          url = `/inventario/${contract._id}/revisar`;
        } // if
      } // if
      this.$router.push({
        path: url,
      });
    },
    downloadPDF(id) {
      this.isLoadingPDF = true;
      return new Promise(() => {
        const config = {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        };
        axios.get("/inventarios/print" + `/${id}`, config).then((response) => {
          this.isLoadingPDF = false;
          if (response.status === 200) {
            downloadPDF(response, "inventario.pdf");
          }
        });
      });
    },
  },
};
</script>

<style scoped>
.intermitente {
  box-shadow: 0px 0px 20px;
  animation: infinite resplandorAnimation 2s;
}

@keyframes resplandorAnimation {

  0%,
  100% {
    box-shadow: 0px 0px 10px #ed7d31;
  }

  50% {
    box-shadow: 0px 0px 0px #ed7d31;
  }
}

.display-none {
  display: none;
}

.iconBtn {
  width: 25px;
  cursor: pointer;
}

.inventoryTable {
  margin-top: 20px;
}

.search {
  max-width: 340px;
}

.button_img {
  vertical-align: middle;
  border: none;
  padding: 0;
  background-color: transparent;
  margin: 10px;
}

.content {
  min-height: 50vh;
}

.inventario_estado_vencido {
  background-color: #b84858;
}

.inventario_estado_undefined {
  background-color: red;
}

.inventario_estado_0 {
  background-color: grey;
}

.inventario_estado_1 {
  background-color: #e4d306;
  color: black;
}

.inventario_estado_2 {
  background-color: #6bc45b;
}

.inventario_estado_3 {
  background-color: orange;
}

.inventario_estado_4 {
  background-color: #e4d306;
}
</style>
